import { Injectable } from '@angular/core';
import { QualityControlMeasureItemService } from '../../../views/quality-control-inspection-data/services/measure-item.service';
import { InspectionAssemblyItem } from '../../../api/elite/types/inspection-assembly-item';
import { Observable, of } from 'rxjs';
import {
  QualityControlInspectionDataDetailsComponent,
  QualityControlInspectionDataDetailsTypes,
} from '../../../views/quality-control-inspection-data/dialog/data-measurement/data-measurement.component';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HosesQualityControlMeasureItemService extends QualityControlMeasureItemService {
  override addEditMeasure(
    item?: InspectionAssemblyItem,
    specificGroups?: number,
    options?: { itemName?: string; quantityPerInspection?: boolean }
  ): Observable<undefined | InspectionAssemblyItem> {
    return this.apiRouter.toolTypes().pipe(
      switchMap((toolTypes) =>
        this.dialog
          .open(QualityControlInspectionDataDetailsComponent, {
            data: {
              item,
              specificGroups,
              itemName: options.itemName,
              toolTypes,
              showTimesToMeasure: true,
              isReadonly: !this.authService.editInspectionSheet(),
            },
            minWidth: '80%',
          })
          .afterClosed()
      ),
      switchMap(
        (
          res: /*QualityControlDataMeasurementTypes*/ QualityControlInspectionDataDetailsTypes['result']
        ) => {
          if (!res) {
            return of(undefined);
          }

          return item
            ? this.apiRouter.update(item.id, res)
            : this.apiRouter.add(res);
        }
      )
    );
  }
}
